import app from 'app';
import templateUrl from './submitClaimSelector.html';
import './submitClaimSelector.scss';

import { logEvent, eventCategories } from 'helpers/analytics';

function SubmitClaimSelector() {
  const SubmitClaimSelector = this;

  SubmitClaimSelector.next = () => {
    logEvent('MSOONstepCompleted', {
      category: eventCategories.MSOON,
      stepName: 'choose your claim type'
    });
    SubmitClaimSelector.page = SubmitClaimSelector.planType;
  };

  SubmitClaimSelector.$onInit = () => {
    SubmitClaimSelector.showPlanTypeSelector =
      SubmitClaimSelector.planTypes.length > 0;

    SubmitClaimSelector.planTypeOptions = SubmitClaimSelector.planTypes.map(
      x => {
        const value = x.toLowerCase();
        const label = x.charAt(0).toUpperCase() + value.slice(1);
        return {
          value,
          label
        };
      }
    );
  };
}

app.component('submitClaimSelector', {
  bindings: {
    page: '=',
    planTypes: '<',
    planType: '=',
    sponsorId: '<'
  },
  controller: SubmitClaimSelector,
  controllerAs: 'SubmitClaimSelector',
  templateUrl
});

export default 'submitClaimSelector';
